export default __webpack_public_path__ + "static/media/7.6fa0b716.webp";